module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-wrapper",
    class: {
      'iframe-wrapper': _vm.isIframe
    }
  }, [(!_vm.isIframe) ? _c('video', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "controls": "",
      "poster": _vm.videoPostersrc
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.videosrc,
      "type": "video/mp4"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isIframe) ? _c('iframe', {
    attrs: {
      "src": _vm.iframesrc,
      "width": "100%",
      "height": "100%"
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-103adada","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoWrapper.vue
// module id = 312
// module chunks = 0